module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av35-07dcb470ad4757bd1889c691d3cf9721.jpg";